import React from 'react';
import classNames from 'classnames/bind';
import { DIMENSION_GROUPS, useGetDimensionGroup } from "../../../../hooks/useGetDimensionGroup";
import { DeviceTag } from "../../../DeviceTag";
import style from "./styles.module.pcss";
var cx = classNames.bind(style);
export var PromoBadgesList = function PromoBadgesList(_ref) {
  var promoBadges = _ref.promoBadges,
    promoBadgeSize = _ref.promoBadgeSize;
  var dimension = useGetDimensionGroup();
  var isMobile = dimension === DIMENSION_GROUPS.mobile;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('badge-wrapper')
  }, promoBadges === null || promoBadges === void 0 ? void 0 : promoBadges.map(function (badge) {
    return /*#__PURE__*/React.createElement("div", {
      className: cx('badge')
    }, /*#__PURE__*/React.createElement(DeviceTag, {
      help: badge.help,
      isTooltip: !!badge.help && !isMobile,
      size: promoBadgeSize,
      textColor: badge.textColor,
      variant: badge.variant
    }, badge.children));
  }));
};